import moment from "moment";
import React, { useEffect, useState, useCallback } from "react";
import { RiDownloadLine } from "react-icons/ri";
import { ChevronDown, ChevronUp, Users, Calendar, AlertCircle } from "react-feather";
import { DashboardHr, getDaysInMonth, tableHeaders } from "../../Constant/HR/Dashboard";
import { Link } from "react-router-dom";
import {
  blobErrHandler,
  checkStatusCodeSuccess,
  extractYearMonth,
  extractYearWiseDate,
  fileDownload,
  formatDate,
  handleResponse,
  isRequired,
  moduleName,
  getLocalItem,
} from "../../Constant/common";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { attendanceMusterRollReport } from "../../Api/HrDashboard";
import { notFound, Submit } from "../../Constant";
import { toast } from "react-toastify";
import { useSelectedCenter } from "../CenterContext";
import { staffAttendanceMusterApi } from "../../Api/reportApi";
import {
  cycleDateRadio,
  formikvalidationFunction,
  pdfExcelRadio,
  reportEnums,
  reportPayloadFunction,
} from "../../Constant/Report/report";
import { useFormik } from "formik";
import BaseModal from "../../BaseComponents/BaseModal";
import BaseRadioGroup from "../../BaseComponents/BaseRadio";
import BaseDatePicker from "../../BaseComponents/BaseDatePicker";
import BaseTooltip from "../../BaseComponents/BaseTooltip";
import { PlaceHolderFormat } from "../../Constant/requireMessage";
import { usePageLoader } from "../../_helper/loading/LoadingContext";

/* ── Stat card config ─────────────────────────────────────────────────── */
const STAT_CONFIG = {
  [DashboardHr.PRESENT]: { color: "#10b981", bg: "rgba(16,185,129,0.12)", abbr: "P" },
  [DashboardHr.ABSENT]: { color: "#f43f5e", bg: "rgba(244,63,94,0.12)", abbr: "A" },
  [DashboardHr.NOTMARKED]: { color: "#64748b", bg: "rgba(100,116,139,0.12)", abbr: "NM" },
  [DashboardHr.HALFDAY]: { color: "#f59e0b", bg: "rgba(245,158,11,0.12)", abbr: "HD" },
  [DashboardHr.ONLEAVE]: { color: "#6366f1", bg: "rgba(99,102,241,0.12)", abbr: "L" },
  [DashboardHr.COMPOFF]: { color: "#8b5cf6", bg: "rgba(139,92,246,0.12)", abbr: "CO" },
  [DashboardHr.WEEKOFF]: { color: "#06b6d4", bg: "rgba(6,182,212,0.12)", abbr: "WO" },
  [DashboardHr.HOLIDAY]: { color: "#f97316", bg: "rgba(249,115,22,0.12)", abbr: "H" },
  [DashboardHr.UNPAID]: { color: "#ef4444", bg: "rgba(239,68,68,0.12)", abbr: "UL" },
  [DashboardHr.DEACTIVATED]: { color: "#94a3b8", bg: "rgba(148,163,184,0.12)", abbr: "D" },
};

const STATUS_ABBR_MAP = {
  [DashboardHr.PRESENT]: "P",
  [DashboardHr.ABSENT]: "A",
  [DashboardHr.COMPOFF]: "CO",
  [DashboardHr.HOLIDAY]: "H",
  [DashboardHr.HALFDAY]: "HD",
  [DashboardHr.PAIDLEAVE]: "L",
  [DashboardHr.NOTMARKED]: "NM",
  [DashboardHr.UNPAID]: "UL",
  [DashboardHr.WEEKOFF]: "WO",
};

const STATUS_COLOR = {
  P: { color: "#10b981", bg: "rgba(16,185,129,0.15)" },
  A: { color: "#f43f5e", bg: "rgba(244,63,94,0.15)" },
  CO: { color: "#8b5cf6", bg: "rgba(139,92,246,0.15)" },
  H: { color: "#f97316", bg: "rgba(249,115,22,0.15)" },
  HD: { color: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
  L: { color: "#6366f1", bg: "rgba(99,102,241,0.15)" },
  NM: { color: "#64748b", bg: "rgba(100,116,139,0.15)" },
  UL: { color: "#ef4444", bg: "rgba(239,68,68,0.15)" },
  WO: { color: "#06b6d4", bg: "rgba(6,182,212,0.15)" },
};

const STATUS_FULL_NAME = {
  P: DashboardHr.PRESENT,
  A: DashboardHr.ABSENT,
  CO: DashboardHr.COMPOFF,
  H: DashboardHr.HOLIDAY,
  HD: DashboardHr.HALFDAY,
  L: DashboardHr.ONLEAVE,
  NM: DashboardHr.NOTMARKED,
  UL: DashboardHr.UNPAID,
  WO: DashboardHr.WEEKOFF,
};

const HrDashboard = () => {
  const [selectedReportDate, setSelectedReportDate] = useState(new Date());
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(moment().startOf("month"));
  const [expandAll, setExpandAll] = useState(false);
  const [attendanceReportData, setAttendanceReportData] = useState([]);
  const [attendanceReport, setAttendanceReport] = useState([]);
  const [modal, setModal] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);
  const { setLoading } = usePageLoader();
  const { selectedCenterPayload } = useSelectedCenter();

  const permissions = JSON.parse(getLocalItem("permissions")) || [];
  const hasReportPermission = permissions?.some((p) => p.module_name === moduleName.Report);
  const hasStaffAttendancePermission = permissions?.some(
    (p) => p.module_name === moduleName.StaffAttendance,
  );

  useEffect(() => {
    document.title = DashboardHr.title;
  }, []);

  /* ── Fetch muster roll ── */
  const fetchMusterReportData = useCallback(
    (date) => {
      setLoading(true);
      const userRole = getLocalItem("role");
      const userId = getLocalItem("id");
      const payload = {
        ...selectedCenterPayload,
        searchDate: extractYearMonth(date),
        ...(userRole === "Staff" && userId ? { staff_id: Number(userId) } : {}),
      };
      attendanceMusterRollReport(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res.statusCode)) {
            setAttendanceReport(res.data?.transformedResponse);
            setAttendanceReportData(res.data?.transformedResponse);
          } else toast.error(res.message);
        })
        .catch(() => setAttendanceReport([]))
        .finally(() => setLoading(false));
    },
    [selectedCenterPayload, setLoading],
  );

  /* ── Fetch single-staff detail ── */
  const handleReportDataChange = (date, staffId) => {
    setLoading(true);
    attendanceMusterRollReport({
      ...selectedCenterPayload,
      searchDate: extractYearMonth(date),
      staff_id: staffId,
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode))
          setAttendanceReportData(res.data?.transformedResponse);
        else toast.error(res.message);
      })
      .catch(() => setAttendanceReportData([]))
      .finally(() => setLoading(false));
  };

  const toggleRow = (rowId) => {
    if (expandAll) return;
    const next = expandedRow === rowId ? null : rowId;
    setExpandedRow(next);
    if (next) handleReportDataChange(selectedReportDate, rowId);
  };

  const handleExpandAll = () => {
    const next = !expandAll;
    setExpandAll(next);
    if (next) fetchMusterReportData(selectedReportDate);
    setExpandedRow(null);
  };

  useEffect(() => {
    fetchMusterReportData(selectedReportDate);
  }, [selectedReportDate, fetchMusterReportData]);

  /* ── Download formik ── */
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cycle_date: null,
      date_range_from: null,
      date_range_end: null,
      pdf_excel: null,
    },
    validationSchema: formikvalidationFunction(reportEnums.musterRoll, dateRange),
    onSubmit: (values) => {
      setBtnLoader(true);
      const payload = reportPayloadFunction(
        reportEnums.musterRoll,
        formik,
        selectedCenterPayload,
        values.cycle_date,
      );
      staffAttendanceMusterApi(payload)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.status)) {
            const type =
              values.pdf_excel === reportEnums.PDF
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            fileDownload(resp?.data, type, reportEnums.musterRollName);
            toast.success(resp?.success);
            setModal(false);
            formik.resetForm();
          } else toast.error(resp);
        })
        .catch(blobErrHandler)
        .finally(() => setBtnLoader(false));
    },
  });

  /* ── Calendar detail row ── */
  const CalendarRow = ({ attendanceData }) => {
    const daysInMonth = getDaysInMonth(selectedMonth);
    const dataMap = daysInMonth.reduce((acc, { day }) => {
      acc[formatDate(selectedMonth, day)] = {
        total_working_hours: handleResponse.nullData,
        attendance_status: handleResponse.nullData,
      };
      return acc;
    }, {});
    (attendanceData || []).forEach((entry) => {
      const key = extractYearWiseDate(entry.date);
      if (dataMap[key]) {
        let wh = entry?.total_working_hours ?? handleResponse.nullData;
        if (typeof wh === "string") wh = wh.replace(" hours", "");
        dataMap[key] = {
          total_working_hours: wh,
          attendance_status: entry.attendance_status || handleResponse.nullData,
        };
      }
    });

    return (
      <div style={{ overflowX: "auto", padding: "16px" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse", minWidth: 600, fontSize: "0.75rem" }}
        >
          <thead>
            <tr>
              <td
                style={{
                  padding: "6px 10px",
                  fontWeight: 700,
                  color: "var(--text-muted)",
                  background: "var(--table-header-bg)",
                  borderRadius: "8px 0 0 0",
                  whiteSpace: "nowrap",
                  minWidth: 60,
                }}
              >
                {DashboardHr.DAYS}
              </td>
              {daysInMonth.map(({ day, dayOfWeek }) => (
                <td
                  key={day}
                  style={{
                    padding: "4px 6px",
                    textAlign: "center",
                    background: "var(--table-header-bg)",
                    color: "var(--text-muted)",
                    fontWeight: 600,
                  }}
                >
                  <div style={{ fontSize: "0.625rem", color: "var(--text-muted)" }}>
                    {dayOfWeek}
                  </div>
                  <div style={{ fontWeight: 700, color: "var(--text-primary)" }}>{day}</div>
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: "6px 10px",
                  fontWeight: 600,
                  color: "var(--text-muted)",
                  background: "rgba(99,102,241,0.04)",
                  whiteSpace: "nowrap",
                }}
              >
                {DashboardHr.WorkingHoursLabel}
              </td>
              {daysInMonth.map(({ day }) => {
                const d = dataMap[formatDate(selectedMonth, day)];
                return (
                  <td
                    key={day}
                    style={{
                      padding: "4px 6px",
                      textAlign: "center",
                      color: "var(--text-secondary)",
                      fontSize: "0.6875rem",
                    }}
                  >
                    {d.total_working_hours}
                  </td>
                );
              })}
            </tr>
            <tr>
              <td
                style={{
                  padding: "6px 10px",
                  fontWeight: 600,
                  color: "var(--text-muted)",
                  background: "rgba(99,102,241,0.04)",
                  whiteSpace: "nowrap",
                }}
              >
                {DashboardHr.Status}
              </td>
              {daysInMonth.map(({ day }) => {
                const d = dataMap[formatDate(selectedMonth, day)];
                const rawStatus =
                  d.attendance_status === DashboardHr.PaidLeaveStatus
                    ? DashboardHr.PAIDLEAVE
                    : d.attendance_status;
                const abbr = STATUS_ABBR_MAP[rawStatus] || handleResponse.nullData;
                const sc = STATUS_COLOR[abbr] || {};
                const fullName = STATUS_FULL_NAME[abbr];
                return (
                  <td key={day} style={{ padding: "4px 6px", textAlign: "center" }}>
                    {abbr !== handleResponse.nullData ? (
                      <BaseTooltip text={fullName} position="top">
                        <span
                          style={{
                            display: "inline-block",
                            minWidth: 22,
                            padding: "2px 4px",
                            borderRadius: 4,
                            fontSize: "0.625rem",
                            fontWeight: 700,
                            background: sc.bg,
                            color: sc.color,
                          }}
                        >
                          {abbr}
                        </span>
                      </BaseTooltip>
                    ) : (
                      <span style={{ color: "var(--text-muted)", fontSize: "0.625rem" }}>—</span>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  /* ── JSX ── */
  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* ── Page header ── */}
      <div
        className="animate-slide-down"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "1.375rem",
              fontWeight: 800,
              margin: 0,
              color: "var(--text-primary)",
            }}
          >
            Attendance Dashboard
          </h1>
          <p style={{ margin: 0, fontSize: "0.8125rem", color: "var(--text-muted)", marginTop: 2 }}>
            Real-time attendance overview for all staff
          </p>
        </div>
        {hasStaffAttendancePermission && (
          <Link
            to="/staff-attendance"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 16px",
              borderRadius: 10,
              background: "rgba(99,102,241,0.1)",
              color: "var(--brand-indigo)",
              fontSize: "0.8125rem",
              fontWeight: 600,
              textDecoration: "none",
              border: "1px solid rgba(99,102,241,0.2)",
              transition: "all 0.15s",
            }}
          >
            <Users size={14} strokeWidth={2} />
            {DashboardHr.ATTENDENCEVIEW}
          </Link>
        )}
      </div>

      {/* ── Muster Roll section ── */}
      <div
        className="animate-slide-up"
        style={{
          animationDelay: "60ms",
          background: "var(--glass-bg)",
          border: "1px solid var(--glass-border)",
          borderRadius: 20,
          overflow: "hidden",
        }}
      >
        {/* Section header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "1px solid var(--glass-border)",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: "rgba(99,102,241,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Calendar size={16} strokeWidth={2} style={{ color: "var(--brand-indigo)" }} />
            </div>
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: "0.9375rem",
                  fontWeight: 700,
                  color: "var(--text-primary)",
                }}
              >
                {DashboardHr.ATTENDENCEREPORT}
              </h2>
              <p style={{ margin: 0, fontSize: "0.75rem", color: "var(--text-muted)" }}>
                {DashboardHr.MONTHLYREGULAR}
              </p>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            {/* Expand/collapse all */}
            <button
              onClick={handleExpandAll}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "7px 14px",
                borderRadius: 10,
                background: expandAll ? "rgba(99,102,241,0.1)" : "var(--icon-btn-bg)",
                border: "1px solid var(--glass-border)",
                color: expandAll ? "var(--brand-indigo)" : "var(--text-secondary)",
                fontSize: "0.8125rem",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.15s",
              }}
            >
              {expandAll ? (
                <ChevronUp size={14} strokeWidth={2} />
              ) : (
                <ChevronDown size={14} strokeWidth={2} />
              )}
              {expandAll ? DashboardHr.COLLAPSEALL : DashboardHr.EXPANDALL}
            </button>

            {/* Download */}
            {hasReportPermission && (
              <button
                onClick={() => setModal(true)}
                aria-label={DashboardHr.DOWNLOAD}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "7px 14px",
                  borderRadius: 10,
                  background: "rgba(16,185,129,0.1)",
                  border: "1px solid rgba(16,185,129,0.2)",
                  color: "#10b981",
                  fontSize: "0.8125rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.15s",
                }}
              >
                <RiDownloadLine size={15} />
                {DashboardHr.DOWNLOAD}
              </button>
            )}

            {/* Month picker */}
            <div style={{ position: "relative" }}>
              <DatePicker
                className="form-control"
                selected={selectedReportDate}
                onChange={(date) => {
                  setSelectedReportDate(date);
                  setSelectedMonth(moment(date).startOf("month"));
                }}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                maxDate={new Date()}
                style={{ borderRadius: 10, fontSize: "0.8125rem" }}
              />
            </div>
          </div>
        </div>

        {/* Legend */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            padding: "12px 20px",
            borderBottom: "1px solid var(--glass-border)",
            background: "rgba(99,102,241,0.02)",
          }}
        >
          {Object.entries(STATUS_COLOR).map(([abbr, sc]) => (
            <BaseTooltip key={abbr} text={STATUS_FULL_NAME[abbr]} position="top">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "3px 8px",
                  borderRadius: 6,
                  fontSize: "0.6875rem",
                  fontWeight: 700,
                  background: sc.bg,
                  color: sc.color,
                }}
              >
                {abbr}
              </span>
            </BaseTooltip>
          ))}
          <span
            style={{
              fontSize: "0.6875rem",
              color: "var(--text-muted)",
              alignSelf: "center",
              marginLeft: 4,
            }}
          >
            — Status codes
          </span>
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
            <thead>
              <tr style={{ background: "var(--table-header-bg)" }}>
                <th style={{ width: 40, padding: "12px 16px", textAlign: "center" }}>
                  {/* expand icon col */}
                </th>
                {tableHeaders.map((h, i) => (
                  <th
                    key={i}
                    style={{
                      padding: "12px 14px",
                      textAlign: i === 0 ? "left" : "center",
                      fontSize: "0.6875rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.07em",
                      color: "var(--text-muted)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {h.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {attendanceReport?.length > 0 ? (
                attendanceReport.map((row) => {
                  const isExpanded = expandedRow === row.staff_id || expandAll;
                  const cols = [
                    row?.statusCount?.present,
                    row?.statusCount?.absent,
                    row?.statusCount?.halfDay,
                    row?.statusCount?.paidLeave,
                    row?.statusCount?.unmarked,
                    row?.statusCount?.compOff,
                    row?.statusCount?.holiday,
                    row?.statusCount?.weekOff,
                    row?.statusCount?.unpaidLeave,
                    row?.statusCount?.totalDays,
                  ];
                  return (
                    <React.Fragment key={row.staff_id}>
                      <tr
                        onClick={() => toggleRow(row.staff_id)}
                        style={{
                          cursor: "pointer",
                          borderBottom: "1px solid var(--glass-border)",
                          background: isExpanded ? "rgba(99,102,241,0.04)" : "transparent",
                          transition: "background 0.15s",
                        }}
                        onMouseEnter={(e) => {
                          if (!isExpanded) e.currentTarget.style.background = "var(--nav-hover)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = isExpanded
                            ? "rgba(99,102,241,0.04)"
                            : "transparent";
                        }}
                      >
                        {/* Expand toggle */}
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 24,
                              height: 24,
                              borderRadius: 6,
                              background: isExpanded
                                ? "rgba(99,102,241,0.15)"
                                : "var(--icon-btn-bg)",
                              color: isExpanded ? "var(--brand-indigo)" : "var(--text-muted)",
                              transition: "all 0.15s",
                            }}
                          >
                            {isExpanded ? (
                              <ChevronUp size={13} strokeWidth={2.5} />
                            ) : (
                              <ChevronDown size={13} strokeWidth={2.5} />
                            )}
                          </span>
                        </td>

                        {/* Name */}
                        <td
                          style={{
                            padding: "12px 14px",
                            fontWeight: 600,
                            color: "var(--text-primary)",
                            fontSize: "0.875rem",
                          }}
                        >
                          {row.name || handleResponse.nullData}
                        </td>

                        {/* Stat cols */}
                        {cols.map((val, ci) => {
                          const headers = [
                            DashboardHr.PRESENT,
                            DashboardHr.ABSENT,
                            DashboardHr.HALFDAY,
                            DashboardHr.ONLEAVE,
                            DashboardHr.NOTMARKED,
                            DashboardHr.COMPOFF,
                            DashboardHr.HOLIDAY,
                            DashboardHr.WEEKOFF,
                            DashboardHr.UNPAID,
                            null,
                          ];
                          const cfg = STAT_CONFIG[headers[ci]];
                          const hasVal = val !== undefined && val !== null && val !== 0;
                          return (
                            <td key={ci} style={{ padding: "12px 14px", textAlign: "center" }}>
                              {hasVal && cfg ? (
                                <span
                                  style={{
                                    display: "inline-block",
                                    minWidth: 28,
                                    padding: "3px 8px",
                                    borderRadius: 6,
                                    fontSize: "0.8125rem",
                                    fontWeight: 700,
                                    background: cfg.bg,
                                    color: cfg.color,
                                  }}
                                >
                                  {val}
                                </span>
                              ) : (
                                <span style={{ color: "var(--text-muted)", fontSize: "0.8125rem" }}>
                                  {val ?? "—"}
                                </span>
                              )}
                            </td>
                          );
                        })}
                      </tr>

                      {/* Expanded calendar row */}
                      {isExpanded && (
                        <tr style={{ background: "rgba(99,102,241,0.02)" }}>
                          <td
                            colSpan={tableHeaders.length + 1}
                            style={{ padding: 0, borderBottom: "1px solid var(--glass-border)" }}
                          >
                            <CalendarRow
                              attendanceData={
                                expandAll
                                  ? row.attendanceData
                                  : attendanceReportData[0]?.attendanceData
                              }
                            />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length + 1}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "60px 20px",
                        gap: 12,
                      }}
                    >
                      <AlertCircle size={40} style={{ color: "var(--text-muted)", opacity: 0.4 }} />
                      <p style={{ color: "var(--text-muted)", margin: 0 }}>
                        {notFound.dataNotFound}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Download modal ── */}
      <BaseModal
        isOpen={modal}
        title={reportEnums.musterRoll}
        toggler={() => {
          setModal(false);
          formik.resetForm();
        }}
        submit={formik.handleSubmit}
        submitText={Submit}
        disabled={btnLoader}
        loader={btnLoader}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="mx-3">
            <div className="form-label mb-1">
              {reportEnums.downloadBy}
              {isRequired}
            </div>
            <BaseRadioGroup
              name="cycle_date"
              options={cycleDateRadio}
              selectedValue={formik.values.cycle_date}
              onChange={(e) => {
                formik.setFieldValue("cycle_date", e.target.value);
                setDateRange(e.target.value);
              }}
              value={formik.values.cycle_date}
              touched={formik.touched.cycle_date}
              error={formik.errors.cycle_date}
              handleBlur={formik.handleBlur}
            />
          </div>

          {dateRange === reportEnums.dateRange && (
            <div className="mx-3">
              <div className="mb-2">{reportEnums.dateRange}</div>
              <div className="d-flex gap-2 mb-4">
                <BaseDatePicker
                  name="date_range_from"
                  label={reportEnums.reportCycleFrom}
                  value={formik.values.date_range_from}
                  onChange={(v) => formik.setFieldValue("date_range_from", v)}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.date_range_from}
                  error={formik.errors.date_range_from}
                  placeholder={PlaceHolderFormat(reportEnums.reportCycleFrom)}
                  required
                />
                <BaseDatePicker
                  name="date_range_end"
                  label={reportEnums.reportCycleEnd}
                  value={formik.values.date_range_end}
                  onChange={(v) => formik.setFieldValue("date_range_end", v)}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.date_range_end}
                  error={formik.errors.date_range_end}
                  placeholder={PlaceHolderFormat(reportEnums.reportCycleEnd)}
                  required
                />
              </div>
            </div>
          )}

          {dateRange === reportEnums.salaryCycle && (
            <div className="mx-3 mb-3">
              <label className="form-label">
                {reportEnums.reportCycle}
                {isRequired}
              </label>
              <DatePicker
                className="form-control"
                selected={formik.values.report_cycle}
                onChange={(date) => formik.setFieldValue("report_cycle", date)}
                placeholderText={reportEnums.reportCycle}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                maxDate={new Date()}
              />
              {formik.touched.report_cycle && formik.errors.report_cycle && (
                <div className="text-danger mt-1" style={{ fontSize: "0.8125rem" }}>
                  {formik.errors.report_cycle}
                </div>
              )}
            </div>
          )}

          <div className="mx-3">
            <div className="form-label mb-1">
              {reportEnums.reportType}
              {isRequired}
            </div>
            <BaseRadioGroup
              name="pdf_excel"
              options={pdfExcelRadio}
              selectedValue={formik.values.pdf_excel}
              onChange={(e) => formik.setFieldValue("pdf_excel", e.target.value)}
              value={formik.values.pdf_excel}
              touched={formik.touched.pdf_excel}
              error={formik.errors.pdf_excel}
              handleBlur={formik.handleBlur}
            />
          </div>
        </form>
      </BaseModal>
    </div>
  );
};

export default HrDashboard;
